var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUrbaneaseIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 115,
    height: 72,
    viewBox: "0 0 115 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_2)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.953 51.6L22.3554 50.6L24.953 49.6L25.1386 50.1L23.747 50.7L25.1386 51.2L24.953 51.6Z",
    fill: "#D41031"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M70.5036 33L68.4626 32.2L66.8855 32.9L66.7 32.4L68.4626 31.7L70.6892 32.6L70.5036 33ZM59.3711 35.9L59.1855 35.4L62.9892 33.8L63.1747 34.3L59.3711 35.9ZM78.1108 36.1L74.3072 34.5L74.4928 34L78.2964 35.6L78.1108 36.1ZM51.7639 39L51.5783 38.5L55.3819 36.9L55.5675 37.4L51.7639 39ZM85.7181 39.2L81.9145 37.6L82.1 37.1L85.9036 38.7L85.7181 39.2ZM44.1566 42.1L43.9711 41.6L47.7747 40L47.9602 40.5L44.1566 42.1ZM93.3253 42.3L89.5217 40.7L89.7072 40.2L93.5108 41.8L93.3253 42.3ZM36.5494 45.2L36.3639 44.7L40.1675 43.1L40.353 43.6L36.5494 45.2ZM100.84 45.5L97.0361 43.9L97.2217 43.4L101.025 45L100.84 45.5ZM29.0349 48.4L28.8494 47.9L32.653 46.3L32.8386 46.8L29.0349 48.4ZM108.447 48.6L104.643 47L104.829 46.5L108.633 48.1L108.447 48.6Z",
    fill: "#D41031"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M111.601 51.6L111.416 51.1L112.807 50.6L111.416 50L111.601 49.5L114.199 50.5L111.601 51.6Z",
    fill: "#D41031"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.653 55.6L28.8494 54L29.0349 53.5L32.8386 55.1L32.653 55.6ZM104.829 55.8L104.643 55.3L108.447 53.7L108.633 54.2L104.829 55.8ZM40.1675 58.7L36.3639 57.1L36.5494 56.6L40.353 58.2L40.1675 58.7ZM97.2217 58.9L97.0361 58.4L100.84 56.8L101.025 57.3L97.2217 58.9ZM47.7747 61.9L43.9711 60.3L44.1566 59.8L47.9602 61.4L47.7747 61.9ZM89.6145 62.1L89.4289 61.6L93.3253 60L93.5108 60.5L89.6145 62.1ZM55.3819 65L51.5783 63.4L51.7639 62.9L55.5675 64.5L55.3819 65ZM82.1 65.2L81.9145 64.7L85.7181 63.1L85.9036 63.6L82.1 65.2ZM62.9892 68.1L59.1855 66.5L59.3711 66L63.1747 67.6L62.9892 68.1ZM74.4928 68.3L74.3072 67.8L78.1108 66.2L78.2964 66.7L74.4928 68.3ZM68.9265 70.6L66.7 69.7L66.8855 69.2L68.9265 70L70.5036 69.3L70.6892 69.8L68.9265 70.6Z",
    fill: "#D41031"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M47.4036 69.6C14.3771 56.1 34.0446 64.1 3.24458 51.6L47.1253 33.6L91.2843 51.6C55.3819 66.3 68.9265 60.7 47.4036 69.6ZM92.3976 49.9L47.5892 31.6C47.2181 31.4 46.7542 31.4 46.3831 31.6L1.94578 49.9C1.29638 50.2 0.925301 50.8 0.925301 51.5C0.925301 52.2 1.29638 52.9 1.94578 53.1C46.9398 71.5 1.5747 52.9 46.6614 71.4C46.847 71.5 47.0325 71.5 47.2181 71.5C47.4036 71.5 47.5892 71.5 47.7747 71.4C92.5831 53 47.4964 71.5 92.2121 53.1C92.8615 52.8 93.2325 52.2 93.2325 51.5C93.5108 50.8 93.047 50.2 92.3976 49.9Z",
    fill: "#6199C2"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M55.1036 56.7C22.0771 43.2 41.7446 51.2 10.9446 38.7L54.8253 20.7L98.9843 38.7C63.0819 53.4 76.7193 47.8 55.1036 56.7ZM100.19 37L55.3819 18.7C55.0108 18.5 54.547 18.5 54.1759 18.7L9.83132 37C9.18193 37.3 8.81084 37.9 8.81084 38.6C8.81084 39.3 9.18193 40 9.83132 40.2C54.8253 58.6 9.46024 40 54.547 58.5C54.7325 58.6 54.9181 58.6 55.1036 58.6C55.2892 58.6 55.4747 58.6 55.6602 58.5C100.469 40.1 55.3819 58.6 100.098 40.2C100.747 39.9 101.118 39.3 101.118 38.6C101.211 37.9 100.84 37.3 100.19 37Z",
    fill: "#4E55A2"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M64.3807 18.4C64.3807 24.3 59.9277 29.1 54.3614 29.1C48.8879 29.1 44.3422 24.3 44.3422 18.4C44.3422 12.5 48.7952 7.7 54.3614 7.7C59.8349 7.7 64.3807 12.5 64.3807 18.4Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M54.3614 27.6C49.6301 27.6 45.8265 23.5 45.8265 18.4C45.8265 13.3 49.6301 9.2 54.3614 9.2C59.0928 9.2 62.8964 13.3 62.8964 18.4C62.8964 23.5 59.0928 27.6 54.3614 27.6ZM54.3614 0C54.1759 0 53.9904 0 53.712 0C44.2494 0.4 36.8277 8.9 37.1988 19C37.1988 19.9 37.2916 20.9 37.4771 21.8C37.4771 22 37.5699 22.2 37.5699 22.5C37.8482 23.7 38.2193 24.9 38.6831 26.1C40.4458 30.5 45.0843 39.9 53.2482 47.2C53.8976 47.8 54.6397 47.8 55.1964 47.3C61.5976 40.5 67.7205 31.3 69.8542 26.2C70.3181 25 70.7819 23.8 70.9675 22.5C71.0602 22.1 71.0602 21.9 71.0602 21.9C71.2458 20.7 71.3385 19.6 71.3385 18.4C71.5241 8.2 63.8241 0 54.3614 0Z",
    fill: "#D2112F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M54.4542 14C52.2277 14 50.3723 15.9 50.3723 18.3C50.3723 20.7 52.2277 22.7 54.4542 22.7C56.6807 22.7 58.5361 20.8 58.5361 18.3C58.5361 15.9 56.6807 14 54.4542 14Z",
    fill: "#D2112F"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_2"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 115,
    height: 72,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUrbaneaseIcon);
export default __webpack_public_path__ + "static/media/urbaneaseIcon.3abdc24a65e1b9b99182042a70d9754e.svg";
export { ForwardRef as ReactComponent };